import { createFileRoute, Navigate } from '@tanstack/react-router';
import { useAuth } from '../auth/auth-gate';

const IndexRedirect = () => {
  const { firstTimeLogin } = useAuth();
  return <Navigate to={firstTimeLogin ? '/how-to-play' : '/lobby'} replace />;
};

export const Route = createFileRoute('/')({
  component: IndexRedirect,
});
